import { MenuListProps, default as MuiMenuList } from '@mui/material/MenuList'

export const MenuList = (props: MenuListProps) => {
  return <MuiMenuList {...props} />
}

export default MenuList
